import { TextField, textFieldTemplate as template } from '@microsoft/fast-foundation';
import { TextFieldComponent } from './TextField';
import { inputFieldDefinition } from '../InputField/InputFieldBase';
export const textfieldDefinition = {
    ...inputFieldDefinition('text-field', template),
    baseClass: TextField,
};
export const chameleonTextField = TextFieldComponent.compose(textfieldDefinition);
